import { useState, useRef, useEffect } from 'react';
import { api } from '../services/api';

export default function Chat({ userId, setProfile }) {
  const [messages, setMessages] = useState([
    { role: 'ai', text: '👋 Ciao guerriero! Sono il tuo coach. Come stai combattendo oggi la dipendenza digitale?' }
  ]);
  const [input, setInput]     = useState('');
  const [loading, setLoading] = useState(false);
  const [chatCount, setChatCount] = useState(0); // sessioni XP oggi
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  async function send() {
    const text = input.trim();
    if (!text || loading) return;

    setInput('');
    setMessages(m => [...m, { role: 'user', text }]);
    setLoading(true);

    try {
      const res = await api.chat(userId, text);
      const { response, xpAwarded, xpGained, profile } = res.data;

      const newMessages = [{ role: 'ai', text: response }];

      if (xpAwarded) {
        newMessages.push({ role: 'xp', text: `+${xpGained} XP guadagnati! 💫` });
        setChatCount(c => c + 1);
      } else {
        newMessages.push({ role: 'limit', text: 'Hai raggiunto il limite XP di oggi (3 sessioni). Continua a parlare liberamente!' });
      }

      setMessages(m => [...m, ...newMessages]);
      setProfile(profile);
    } catch {
      setMessages(m => [...m, { role: 'ai', text: '⚠️ Errore di connessione. Riprova.' }]);
    } finally {
      setLoading(false);
    }
  }

  function onKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  }

  return (
    <>
      {chatCount >= 3 && (
        <div style={{ margin: '8px 12px', padding: '10px 14px', background: 'rgba(96,96,160,.12)', border: '1px solid var(--border)', borderRadius: 10, fontSize: 12, color: 'var(--muted)', textAlign: 'center' }}>
          Hai guadagnato tutti gli XP disponibili oggi (3/3 sessioni). Torna domani per altri XP!
        </div>
      )}

      <div className="chat-messages">
        {messages.map((m, i) => (
          <div key={i} className={
            m.role === 'user'  ? 'msg msg-user' :
            m.role === 'xp'    ? 'xp-toast' :
            m.role === 'limit' ? 'xp-limit' :
            'msg msg-ai'
          }>
            {m.text}
          </div>
        ))}
        {loading && (
          <div className="msg msg-ai" style={{ color: 'var(--muted)' }}>
            Il coach sta pensando...
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      <div className="chat-input-row">
        <input className="chat-input" value={input}
               onChange={e => setInput(e.target.value)}
               onKeyDown={onKey}
               placeholder="Come ti senti oggi?" disabled={loading} />
        <button className="send-btn" onClick={send} disabled={loading}>
          {loading ? '⏳' : '➤'}
        </button>
      </div>
    </>
  );
}
